export const appConfig = {
    backendUrl: 'https://app.salesrun.com',
    logging: {
        enableSending: true,
        errorPage: '/error',
        rollbarAccessToken: 'ceec22669ae7473b8138407f28f0d094',
    },
};